import { Box, styled } from "@mui/system";

export const ListingPageContainer = styled(Box)(({ theme }) => ({

  "&.listingPageContainer": {
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(0),
    paddingRight: theme.spacing(0),
    backgroundColor: theme.palette.grey.light,
    minHeight: theme.pageHeight,
  },
  "& .LabelButtonBox": {
    display: "flex",
    justifyContent: "space-between",
    paddingTop: theme.spacing(2),
    alignItems: "center",
  },
  "& .IconBox": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: theme.spacing(1),
    padding: theme.spacing(0.5),
    width: theme.spacing(6),
    height: theme.spacing(6),
    marginRight: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  },
  "& .icon": {
    color: theme.palette.white.main,
  },
  "& .ButtonContainer": {
    display: "flex",
    gap: theme.spacing(1),
  },
}));
